module.exports = __webpack_public_path__ + "img/packaging.b41c3db.jpg";